export default __webpack_public_path__ + "static/media/logo2.e8e50acc.webp";